<template>
  <a-modal :title="title" width="50%" :visible="visible" :confirm-loading="confirmLoading" :maskClosable="false"
    :keyboard="false" @cancel="handleCancel" @ok="submit" ok-text="确认" cancel-text="取消" :destroyOnClose="true">
    <div>
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="年份" prop="evidenceYear">
          <a-date-picker placeholder="请选择年份" v-model="form.evidenceYear" :open="yearShowOne" :locale="locale"
            :format="'YYYY'" mode="year" @openChange="openChangeOne" @panelChange="panelChangeOne"
            @change="handleClearAcquireYear" />
        </a-form-model-item>
        <a-form-model-item label="佐证材料上传" prop="fileName">
          <a-upload :file-list="fileList" :disabled="isEdit" :remove="(file, fileList) => handleRemove(file, fileList)"
             :before-upload="(file, fileList) => beforeUpload(file, fileList)"
            accept=".pdf,.png,.jpeg,.jpg,.mp4">
            <a-button :disabled="(isEdit || loading)" :loading="loading">
              <a-icon type="upload" />上传附件
            </a-button>
            <span class="text2">注：可上传pdf格式的文件,png,jpeg,jpg格式的图片,mp4格式的视频</span>
          </a-upload>
        </a-form-model-item>
         <a-form-model-item label="佐证材料说明">
          <a-textarea v-model="form.evidenceExplain" placeholder="请输入佐证材料说明" :auto-size="{ minRows: 4, maxRows: 6 }" />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction,post1Action, putAction, fileUpdate } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: '',
        fileName: "",
        filePath: "",
        evidenceExplain: '',
        type: '',
        sjId: '',
        evidenceYear: '',
        aliId:'',
        sourceType:'local',
      },
      yearShowOne: false,
      zh_CN,
      locale,
      rules: {
        evidenceYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.evidenceYear != '') {
                callback(); // 验证通过
              } else {
                callback(new Error('请选择年份'));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        fileName: [
          {
            validator: (rule, value, callback) => {
              // console.log(value, this.form.joinYear);
              if (this.form.fileName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请上传佐证材料"));
              }
            },
            required: true,
            message: "请上传佐证材料",
            trigger: "change",
          },
        ],
        // evidenceExplain: [
        //   {
        //     required: true,
        //     message: "请输入佐证材料说明",
        //     trigger: "blur",
        //   },
        // ],
      },
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      fileList: [],
      loading: false,
      file: '',
      sourceType: 'alioss',
      timeout: "",
      partSize: "",
      parallel: "",
      retryCount: "",
      retryDuration: "",
      region: "cn-beijing",
      userId: "1104845979036938",
      uploadDisabled: true,
      resumeDisabled: true,
      statusText: "",
    };
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file,this.fileList,this.form.aliId);
      if(file.type=='video/mp4' || this.form.aliId){
         this.fileList=[];
        this.form.fileName = "";
        this.form.filePath = "";
      }else{
          this.fileList=[];
        this.form.fileName = "";
        this.form.filePath = "";
        //   this.fileList = this.fileList.filter(item => {
        //     if (item.path.indexOf(file.name) === -1) {
        //       return item;
        //   }
         
        // });
        // const index = this.fileList.indexOf(file);
        // const newFileList = this.fileList.slice();
        // newFileList.splice(index, 1);
        // this.form.fileName = "";
        // this.form.filePath = "";
        // this.fileList = newFileList;
      }
      
    },
    changeFile(f, fileList) {
      // && this.sourceType == 'alioss'
    //  console.log(f,"3333");
      if (f.type == "video/mp4" && this.sourceType == "alioss") {
        console.log("此处应该使用阿里云的视频上传");
        this.file = f;
        // 简化的阿里云上传视频
        var userData = '{"Vod":{}}';
        this.uploader = this.createUploader();
        this.uploader.addFile(this.file, null, null, null, userData);
        this.uploader.startUpload();
        
      } else {
      }
      this.fileList = fileList;
    },
    uploadFiles(params) {
      // let obj = {
      //   //添加资源参数
      //   aliId: params.aliId, // 阿里云存放id
      //   // courseId: this.$store.state.courseId, //  课程id
      //   // coverImg: data.coverImgpath, //  封面图片
      //   fileType: params.fileType, // 资源源文件类型
      //   fileUrl: params.fileUrl, // 资源源文件地址
      //   // id:"",            // 主键
      //   name: params.name, // 资源名称
      //   previewUrl: params.previewUrl, // 转换后文件地址
      //   resourceDuration: params.resourceDuration, // 资源时长
      //   // sort: 0, //  排序
      //   sourceType: params.sourceType, // 来源类型
      //   // startClassId: this.$store.state.constructionId, //  开课id
      //   // teachContentId:"",   //  教学内容内容id
      //   // teachingWeek: this.params2.teachingWeek, // 教学周
      //   uid: params.uid,
      // };
      this.form.aliId=params.aliId;
      this.form.sourceType=params.sourceType;
        this.form.fileName =params.name;
        this.form.filePath =params.fileUrl;
        console.log(params);
      // if (params.aliId) {
      //   obj.format = params.format;
      // }
      // this.sourceUploadList.push(obj);
      // console.log(this.sourceUploadList)
    },
    createUploader(type) {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
          self.loading=true;
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)

          // self.$emit("handleIsSubmt", true);
          // console.log("444444",uploadInfo);
          self.$forceUpdate();
           self.loading=true;
          if (!uploadInfo.videoId) {
            // let createUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateUploadVideo?Title=testvod1&FileName=aa.mp4&BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&VideoId=5bfcc7864fc14b96972842172207c9e6'
            // let createUrl='https://vod.cn-shanghai.aliyuncs.com/?Action=CreateUploadVideo' +
            //   '&FileName=' + uploadInfo.file.name+
            //   '&title=UploadTest'

            // axios.get(createUrl).then(({data}) => {
            //   let uploadAuth = data.UploadAuth
            //   let uploadAddress = data.UploadAddress
            //   let videoId = data.VideoId
            //   uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            // })

            // var params = {
            //   FileName:uploadInfo.file.name,
            //   Title:uploadInfo.file.name
            // }
            const params = new FormData();
            params.append("FileName", uploadInfo.file.name);
            params.append("Title", uploadInfo.file.name.split(".")[0]);
            params.append("CateId", "11095");
            postAction("/sys/video/CreateUploadVideo", params).then(res => {
              // console.log(res,'4444444444444444444')
              let uploadAuth = res.result.uploadAuth;
              let uploadAddress = res.result.uploadAddress;
              let videoId = res.result.videoId;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
            self.statusText = "文件开始上传...";
          } else {
            // 如果videoId有值，根据videoId刷新上传凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            // let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            // axios.get(refreshUrl).then(({data}) => {
            //   let uploadAuth = data.UploadAuth
            //   let uploadAddress = data.UploadAddress
            //   let videoId = data.VideoId
            //   uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            // })
              // console.log("444444",'这里');
            postAction(`/sys/video/refresVideoPlayAuth?videoId=${uploadInfo.videoId}`).then(res => {
              let uploadAuth = res.result.uploadAuth;
              let uploadAddress = res.result.uploadAddress;
              let videoId = res.result.videoId;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          self.statusText = "文件上传成功!";
          
          const params = {
            // name: uploadInfo.file.name,
            // path: uploadInfo.object,
            // size: uploadInfo.file.size,
            // fileId: uploadInfo.videoId,
            aliId: uploadInfo.videoId,
            fileType: "VIDEO", //	资源源文件类型
            fileUrl: "", //	资源源文件地址
            name: uploadInfo.file.name, //	资源名称
            previewUrl: "", //	转换后文件地址
            resourceDuration: 0, //	资源时长
            sourceType: "alioss",
            uid: uploadInfo.file.uid,
            format: ".mp4"
          };
          console.log("sssss",params);
          self.loading=false;
          self.uploadFiles(params)
          // self.$emit("uploadFile", params);
          self.fileList.forEach((item, index) => {
            if (item) {
              self.fileList.splice(index, 1);
            }
          });
          self.fileList.push(params);
          // self.showProgress = false;
          // self.$emit("handleIsSubmt", false);
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          let progressPercent = Math.ceil(progress * 100);
          self.authProgress = progressPercent;
          self.percent = progressPercent;
          self.statusText = "文件上传中...";
          console.log(progressPercent,"3333");
          self.loading=true;
          if (progressPercent == 100) {
          }
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          // let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
          // axios.get(refreshUrl).then(({data}) => {
          //   let uploadAuth = data.UploadAuth
          //   uploader.resumeUploadWithAuth(uploadAuth)
          // })

          postAction(`/sys/video/refresVideoPlayAuth?videoId=${uploadInfo.videoId}`).then(res => {
            let uploadAuth = res.result.uploadAuth;
            uploader.resumeUploadWithAuth(uploadAuth);
          });
          self.loading=false;
          self.fileList=[];
          self.statusText = "文件超时...";
        },
        onUploadFailed(){
          console.log("22222");
            self.$message.error('上传失败');
            self.fileList=[];
            self.loading=false;
        },
      });
      return uploader;
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file, fileList);
      return false;
    },
    handleUpload(file,fileList) {
      if (this.fileList.length >= 1) {
        this.$message.error("佐证材料一次只能上传一个文件,请移除后再上传");
        return;
      }
      // console.log(file.type,"4444");
      if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/jpg' && file.type != 'video/mp4' && file.type != 'application/pdf') {
        this.$message.error("请上传规定格式的文件");
        return false;
      }
      console.log("4444");
      this.form.aliId='';
      this.form.sourceType='local';
      if (file.type != 'video/mp4') {
        this.loading = true;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("biz", "linxuan");
        fileUpdate(formData).then(res => {
          if (res.code === 0) {
            this.$message.success(`上传成功`);
            let fileItem = {};
            fileItem.path = res.message;
            fileItem.name = file.name;
            fileItem.uid = file.uid;
            this.fileList.push(fileItem);
            this.form.fileName = file.name;
            this.form.filePath = res.message;
            this.$refs.ruleForm.clearValidate('fileName');
            this.loading = false;
          } else {
            this.$message.error("上传失败");
          }
        });
      }else{
        this.changeFile(file, fileList);
      }
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.loading=false;
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.form.code = record.code;
        this.form.sjId = record.dataId || record.sjId;
        this.form.type = record.type;
        this.form.fileName = "";
        this.form.filePath = "";
        this.form.aliId = "";
        this.form.sourceType = "local";
        this.form.evidenceYear = new Date().getFullYear() + "";
        this.fileList = [];
        this.title = "添加佐证材料";
      } else {
        this.title = "编辑佐证材料";
        // console.log(record);
        this.form = {
          applyId: record.applyId,
          fileName: record.fileName,
          filePath: record.filePath,
          evidenceExplain: record.evidenceExplain,
          type: record.type,
          id: record.id,
          sjId: record.dataId || record.sjId,
          evidenceYear: record.evidenceYear,
          code: record.code,
          aliId: record.aliId,
          sourceType: record.sourceType,
        };
        if(record.aliId){
            if (
            record &&
            record.fileName != "" &&
            record.fileName != null 
          ) {
            this.fileList = [];
            let fileItem = {};
            fileItem.path = record.filePath;
            fileItem.name = record.fileName;
            fileItem.uid = 1;
            this.fileList.push(fileItem);
          }
        }else{
            if (
            record &&
            record.fileName != "" &&
            record.fileName != null &&
            record.filePath != "" &&
            record.filePath != null
          ) {
            this.fileList = [];
            let fileItem = {};
            fileItem.path = record.filePath;
            fileItem.name = record.fileName;
            fileItem.uid = 1;
            this.fileList.push(fileItem);
          }
        }
        
      }
    },
    handleCancel() {
      this.visible = false;
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      const year = moment(value).format('YYYY');
      this.form.evidenceYear = year + "";
      this.yearShowOne = false;
      // this.form.acquireYear = value;
      this.$refs.ruleForm.clearValidate("evidenceYear");
      // this.yearShowOne = false;
    },
    handleClearAcquireYear(val) {
      this.form.evidenceYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        // console.log(valid);
        if (valid) {

          if (this.type == "add") {
            let params = this.form;

            postAction("/lxbase/lxApplyEvidence/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addEvidence");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let params = this.form;
            putAction("/lxbase/lxApplyEvidence/edit", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("编辑成功");
                this.$emit("addEvidence");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
